import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import {
  getDesignationList,
  updateDesignation,
  deleteDesignation,
} from "../superAdminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { showSnackbar, hideSnackbar } from '../../../store/slices/snackbarSlice';
const EditDeleteDesignation = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [isEdit, setIsEdit] = useState<Boolean>(false);
  const [designationList, setDesignationList] = useState<any>([]);
  const [designationName, setDesignationName] = useState<any>("");
  const [designationID, setDesignationID] = useState<any>("");
  const [level, setLevel] = useState<any>("");
  const [designationStatus, setDesignatiStatus] = useState<string>("");
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    dispatch(
      getDesignationList({
        callback: (res: any) => {
          setDesignationList(res?.data);
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: () => {
          dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };

  const handleEdit = (value: any) => {
    setIsEdit(true);
    setDesignationName(value?.name);
    setDesignationID(value?._id);
    setLevel(value?.level);
    setDesignatiStatus(value?.status);
  };

  const onChangeDesignationName = (val: any) => {
    setDesignationName(val);
  };
  const onChangeDesignationLevel = (val: any) => {
    setLevel(val);
  };

  const handleDelete = (value: any) => {
    dispatch(
      deleteDesignation({
        id: value?._id,
        callback: (res: any) => {
          if (res?.status === "success") {
            setIsEdit(false);
            getData();
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 7000);
          }
        },
        errorCallback: () => {
          dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 7000);
        },
      })
    );
  };
  const renderTable = () => {
    return (
      <AdminTable
        tableData={designationList ? designationList : []}
        pagename={"DesignationList"}
        tableHead={["S.N", "Name", "Level", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };
  const handleSubmit = (e: { preventDefault: () => void }) => {
    setIsEdit(true);
    e.preventDefault();
    const Payload = {
      name: designationName,
      level: level,
      status: designationStatus,
    };
    dispatch(
      updateDesignation({
        id: designationID,
        params: Payload,
        callback: (res: any) => {
          setIsEdit(false);
          getData();
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: () => {
          dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    if (designationName === "" || level === "") return true;
  }

  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row align-items-center">
          <div className="col-md-4">
            <LabelInput labelName={"Designation Name"} />
            <InputField
              key={"ex2"}
              placeholder={"Enter Designation Name"}
              setInputText={(value: any) => onChangeDesignationName(value)}
              value={designationName}
            />
          </div>
          <div className="col-md-4">
            <LabelInput labelName={"Designation Level"} />
            <InputField
              key={"ex2"}
              placeholder={"Enter Desigantion Level"}
              setInputText={(value: any) => onChangeDesignationLevel(value)}
              value={level}
            />
          </div>
          <div className="col-md-2">
            <LabelInput labelName={""} />
            <Submitbtn name={"Edit"} disabled={validations()} />
          </div>
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete DepartMent"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius">
          {isEdit ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteDesignation;
